import { useEffect } from 'react';

const useSEO = ({ title, description, keywords, image, url }) => {
  useEffect(() => {
    const siteName = 'Minipore - Water Treatment Solutions';
    const fullTitle = title ? `${title} | Minipore` : siteName;
    const defaultDesc = 'Shanghai Minipore Industrial Co.,Ltd. - Leading manufacturer of RO/UF membranes, filter housings, and water treatment equipment worldwide.';
    const finalDesc = description || defaultDesc;
    const finalImage = image || 'https://filedn.com/lRYNf7eGO3tp3VIi6pVnJX0/totalfilt/logo.png';
    const finalUrl = url ? `https://www.totalfilt.com/#${url}` : 'https://www.totalfilt.com/';

    document.title = fullTitle;

    const setMeta = (name, content, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', finalDesc);
    if (keywords) setMeta('keywords', keywords);
    setMeta('og:title', fullTitle, true);
    setMeta('og:description', finalDesc, true);
    setMeta('og:image', finalImage, true);
    setMeta('og:url', finalUrl, true);
    setMeta('twitter:title', fullTitle, true);
    setMeta('twitter:description', finalDesc, true);
    setMeta('twitter:image', finalImage, true);

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', finalUrl);
  }, [title, description, keywords, image, url]);
};

export default useSEO;